import { ImportAttendeeReadService } from 'domain/application/services/import/ImportAttendeeReadService'
import { ImportAttendee, ImportRace } from 'domain/models/Import/ImportAttendee'
import { EditionId } from 'domain/models/ValueObject/EntityIds'
import { getFromLocalStorage } from 'services/localStorage/getOrSetLocalStorage'
import { ImportAttendeeSchema } from './ImportAttendeeSchema'

const IMPORT_ATTENDEE_KEY = 'importAttendee'

export class LiveImportAttendeeFrontReadService
  implements ImportAttendeeReadService
{
  constructor() {}

  async getImportAttendee(
    editionId: EditionId
  ): Promise<ImportAttendee | null> {
    const localStorageImportAttendee = getFromLocalStorage(
      `${IMPORT_ATTENDEE_KEY}_${editionId}`
    )
    if (localStorageImportAttendee) {
      try {
        const importAttendee = ImportAttendeeSchema.parse(
          JSON.parse(localStorageImportAttendee)
        )
        return importAttendee
      } catch (error) {
        console.error('Error parsing import attendees: ', error)
        return null
      }
    } else {
      return null
    }
  }

  async getImportRaces(): Promise<ImportRace[]> {
    throw new Error('Method not implemented.')
  }
}
